const UNIVERSAL = {
  BASEURL: "https://api.marketing.sveducrm.com/",
  ENCRYPTION_KEY: "#_2023_MARUF_SVCRM",
  JWT_SECRET: "",
};
export default UNIVERSAL;
